import {
  axiosDeleteRequest,
  axiosGetPaginatedRequest,
  axiosGetRequest,
  axiosPatchRequest,
  axiosPostRequest,
  axiosPutRequest,
  getStoriesRoute,
} from '../../api';
import { CreateLikeDto, ReplyDto } from '../../common';
import { Story } from '../stories';
import { ModeratorUpdateStoryCommentDto, StoryComment } from './model';

const PAGE_SIZE = 20;

const getStandardStoryRoute = () => `${getStoriesRoute()}/story`;

export const fetchCommentsForStoryCall = (
  storyId?: string,
  xMsContinuationToken?: string,
  numrecs?: number
) => {
  return axiosGetPaginatedRequest<StoryComment[]>(
    `${getStandardStoryRoute()}/${storyId}/comments/${numrecs ?? PAGE_SIZE}`,
    xMsContinuationToken
  );
};

export const fetchRepliesToCommentsOnStoryCall = (
  storyId?: string,
  commentId?: string,
  xMsContinuationToken?: string,
  numrecs?: number
) => {
  return axiosGetPaginatedRequest<StoryComment[]>(
    `${getStandardStoryRoute()}/${storyId}/comment/${commentId}/comments/${
      numrecs ?? PAGE_SIZE
    }`,
    xMsContinuationToken
  );
};

export const insertCommentOnStoryCall = (storyId: string, data: ReplyDto) => {
  return axiosPostRequest<ReplyDto, StoryComment>(
    `${getStandardStoryRoute()}/${storyId}/comment`,
    data
  );
};

export const insertReplyToCommentOnStoryCall = (
  storyId: string,
  commentId: string,
  data: ReplyDto
) => {
  return axiosPostRequest<ReplyDto, StoryComment>(
    `${getStandardStoryRoute()}/${storyId}/comment/${commentId}`,
    data
  );
};

export const deleteCommentOnStoryCall = (
  storyId: string,
  commentId: string
) => {
  return axiosDeleteRequest(
    `${getStandardStoryRoute()}/${storyId}/comment/${commentId}`
  );
};

export const updateCommentOnStoryCall = (
  storyId: string,
  commentId: string,
  replyDto: ReplyDto
) => {
  return axiosPutRequest<ReplyDto, Story>(
    `${getStandardStoryRoute()}/${storyId}/comment/${commentId}`,
    replyDto
  );
};

export const moderatorUpdateCommentOnStoryCall = (
  storyId: string,
  commentId: string,
  moderatorUpdateStoryCommentDto: ModeratorUpdateStoryCommentDto
) => {
  return axiosPutRequest<ModeratorUpdateStoryCommentDto, StoryComment>(
    `${getStoriesRoute()}/moderator/story/${storyId}/comment/${commentId}`,
    moderatorUpdateStoryCommentDto
  );
};

export const reportStoryCommentCall = (storyId: string, commentId: string) => {
  return axiosPatchRequest(
    `${getStandardStoryRoute()}/${storyId}/comment/${commentId}/report/`
  );
};

export const likeStoryCommentCall = (
  storyId: string,
  commentId: string,
  likeDto: CreateLikeDto
) => {
  return axiosPostRequest<CreateLikeDto, StoryComment>(
    `${getStandardStoryRoute()}/${storyId}/comment/${commentId}/like`,
    likeDto
  );
};

export const moderatorDeleteCommentOnStoryCall = (
  storyId: string,
  commentId: string
) => {
  return axiosDeleteRequest<unknown, StoryComment>(
    `${getStoriesRoute()}/moderator/story/${storyId}/comment/${commentId}`
  );
};

export const fetchStoryCommentCall = (storyId: string, commentId: string) => {
  return axiosGetRequest<StoryComment>(
    `${getStandardStoryRoute()}/${storyId}/comment/${commentId}`
  );
};

export const fetchReplyToStoryCommentCall = (
  storyId: string,
  replyId: string
) => {
  return axiosGetRequest<StoryComment>(
    `${getStandardStoryRoute()}/${storyId}/comment/${replyId}`
  );
};
